import { apiHost } from './apiHost';

// QR ulasan Google tidak memuat tautan Google, melainkan alamat pendek milik kita: <server>/ulasan/<kode>, yang diteruskan server
// ke tautan Google cabang. Tautan asli hanya terlihat oleh superadmin; yang lain hanya menerima ulasanKode dan ulasanAktif.

/** Alamat yang dimuat QR dari konfigurasi cabang ({ ulasanKode, ulasanAktif }); '' bila tautan ulasan belum diisi. */
export const alamatUlasanPendek = (konfigurasi) => {
  const kode = String(konfigurasi?.ulasanKode || '');
  if (!konfigurasi?.ulasanAktif || !/^[A-Za-z0-9]{6,16}$/.test(kode)) return '';
  const protocol = window.location.protocol === 'https:' ? 'https' : 'http';
  return `${protocol}://${apiHost().replace(/^https?:\/\//, '')}/ulasan/${kode}`;
};
